import { FunctionComponent } from "react";

import "./Banner.css";

interface BannerProps {
  className?: string;
  testId?: string;
  children: React.ReactNode;
}

const Banner: FunctionComponent<BannerProps> = ({
  className,
  testId,
  children,
}) => {
  return (
    <div className={`banner ${className}`} data-testid={testId}>
      {children}
    </div>
  );
};

export { Banner };
